import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class triviaListEdit_template extends vnTemplate {

    protected getTemplateHtml(): string {
        return `
        <div class="w-form w-form-large">
            <div class="form-header">
                <h3 class="form-title" data-bind="text: id() ? 'Edit Trivia' : 'New Trivia'"></h3>
                <button data-bind="event: { click: onClickCancel }" class="close-button icon i-close-2" type="button"></button>
            </div>

            <div class="w-form-body">
                <div class="form-body">

                    <div class="form-group row">
                        <label class="form-label form-label-box">Date</label>
                        <input type="date" class="input-text"
                               data-bind="value: triviaDate, disable: isDateDisabled, attr: { min: minDate }">
                    </div>

                    <div class="form-group row">
                        <label class="form-label form-label-box">Title</label>
                        <input type="text" class="input-text" data-bind="value: title">
                    </div>

                    <div class="form-group">
                        <hr class="form">
                    </div>

                    <div class="form-group" style="display:flex; gap:1rem; align-items:center;">
                        <button class="btn-fab btn-fab--small rounded secondary icon-end" type="button"
                                data-bind="event: { click: onClickAddQuestion }">
                            <div class="icon i-plus"></div>
                            <div class="fab-label">Add Question</div>
                        </button>
                        <button class="btn-fab btn-fab--small rounded secondary__light" type="button"
                                data-bind="event: { click: onClickToggleCollapseAll }">
                            <div class="fab-label" data-bind="text: allCollapsed() ? 'Expand All' : 'Collapse All'"></div>
                        </button>
                    </div>

                    <!-- Questions loop -->
                    <div data-bind="foreach: questions" class="form-group">
                        <div class="quiz-question-block"
                             style="margin-bottom:2rem; border:1px solid #ddd; border-radius:4px; padding:1rem; background:#f9f9f9;">

                            <!-- Question header -->
                            <div style="display:flex; justify-content:space-between; align-items:center;">
                                <div style="display:flex; align-items:center; gap:1rem;">
                                    <strong style="cursor:pointer;"
                                            data-bind="text: 'Question ' + ($index() + 1)"></strong>
                                    <button class="btn-fab no-style icon-only icon--xlarge icon i-dropdown-simple"
                                            type="button"
                                            data-bind="event: { click: function(){ $data.collapsed(!$data.collapsed()); } }, css: { 'is-open': !collapsed() }"></button>
                                    <!-- collapsed summary -->
                                    <span style="color:#666; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; max-width:400px;"
                                          data-bind="text: ': ' + questionText(), visible: collapsed()"></span>
                                </div>
                                <button class="btn border only-icon icon i-delete" type="button" title="Remove Question"
                                        data-bind="event: { click: function(){ $parent.removeQuestion($index()); } }"></button>
                            </div>

                            <!-- Question body (collapsible) -->
                            <div data-bind="visible: !collapsed()">
                                <div style="margin-top:1rem;">
                                    <div style="display:flex; align-items:flex-start; gap:1rem; margin-bottom:1rem;">
                                        <label class="form-label" style="min-width:80px; font-weight:600;">Question</label>
                                        <textarea class="input-text" rows="3" style="flex:1;"
                                                  placeholder="Enter question text"
                                                  data-bind="value: questionText"></textarea>
                                    </div>

                                    <div class="quiz-options" style="margin-top:1rem; padding-top:1rem; border-top:1px solid #ddd;">
                                        <label class="form-label" style="font-weight:600; margin-bottom:0.5rem; display:block;">Answer Options</label>

                                        <!-- ko foreach: answers -->
                                        <div class="quiz-option-row" style="display:flex; align-items:center; gap:1rem; margin-bottom:0.5rem;">
                                            <input type="text" class="input-text" style="flex:1;"
                                                   placeholder="Option text"
                                                   data-bind="value: text">
                                            <label style="display:flex; align-items:center; gap:0.3rem; white-space:nowrap;">
                                                <input type="radio" style="display:inline-block;"
                                                       data-bind="checked: $parent.correctAnswerIndex,
                                                                  checkedValue: $index()">
                                                Correct
                                            </label>
                                        </div>
                                        <!-- /ko -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <button class="btn-fab btn-fab--small rounded secondary icon-end" type="button"
                                data-bind="event: { click: onClickAddQuestion }">
                            <div class="icon i-plus"></div>
                            <div class="fab-label">Add Question</div>
                        </button>
                    </div>

                </div>
            </div>

            <div class="form-footer">
                <button type="button" class="btn"
                        data-bind="event: { click: onClickCancel }">Cancel</button>
                <button type="button" class="btn highlight"
                        data-bind="event: { click: onClickSave }">Save</button>
            </div>
        </div>
        `;
    }

    protected getTemplateName(): string {
        return "triviaListEdit-template";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-content"];
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected buildViewModel(): any {
        let self = this;

        const today = new Date();
        const minDate = today.toISOString().slice(0, 10);

        return {
            id:             ko.observable(null),
            triviaDate:     ko.observable(''),
            title:          ko.observable(''),
            questions:      ko.observableArray([]),
            isDateDisabled: ko.observable(false),
            minDate:        ko.observable(minDate),
            allCollapsed:   ko.observable(false),

            onClickAddQuestion: (data, event) => {
                self.addQuestion();
            },
            onClickToggleCollapseAll: (data, event) => {
                self.toggleCollapseAll();
            },
            removeQuestion: (index: number) => {
                self.removeQuestion(index);
            },
            onClickCancel: (data, event) => {
                self.caller.onClickCancelEdit();
            },
            onClickSave: (data, event) => {
                self.caller.save();
            },
        };
    }

    public getViewModelForRequest(): any {
        const vm = this.getTemplateViewModel();
        return {
            id:          vm.id(),
            triviaDate:  vm.triviaDate(),
            title:       vm.title(),
            questions:   vm.questions().map((q: any) => ({
                id:                 q.id,
                questionText:       q.questionText(),
                correctAnswerIndex: q.correctAnswerIndex(),
                answers:            q.answers().map((a: any) => ({ text: a.text() })),
            })),
        };
    }

    // -------------------------------------------------------------------------
    // Public setters called by the module
    // -------------------------------------------------------------------------
    public setId(id: any) {
        this.getTemplateViewModel().id(id);
    }

    public setTriviaDate(date: string) {
        this.getTemplateViewModel().triviaDate(date);
    }

    public setTitle(title: string) {
        this.getTemplateViewModel().title(title);
    }

    public setDateDisabled(disabled: boolean) {
        this.getTemplateViewModel().isDateDisabled(disabled);
    }

    public setQuestions(questions: any[]) {
        const mapped = (questions || []).map((q: any) => this.buildQuestionViewModel(q));
        this.getTemplateViewModel().questions(mapped);
    }

    // -------------------------------------------------------------------------
    // Internal helpers
    // -------------------------------------------------------------------------
    private buildQuestionViewModel(q: any = {}): any {
        const answers = (q.answers && q.answers.length === 5)
            ? q.answers
            : [{text: ''}, {text: ''}, {text: ''}, {text: ''}, {text: ''}];

        return {
            id:                 q.id || null,
            questionText:       ko.observable(q.questionText || ''),
            correctAnswerIndex: ko.observable(q.correctAnswerIndex || 0),
            collapsed:          ko.observable(false),
            answers:            ko.observableArray(
                answers.map((a: any) => ({ text: ko.observable(a.text || '') }))
            ),
        };
    }

    private addQuestion(): void {
        this.getTemplateViewModel().questions.push(this.buildQuestionViewModel());
    }

    private removeQuestion(index: number): void {
        this.getTemplateViewModel().questions.splice(index, 1);
    }

    private toggleCollapseAll(): void {
        const vm      = this.getTemplateViewModel();
        const current = vm.allCollapsed();
        vm.questions().forEach((q: any) => q.collapsed(!current));
        vm.allCollapsed(!current);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/triviaListEdit_template.ts